import { render, staticRenderFns } from "./DataFlow.vue?vue&type=template&id=50f6d495"
import script from "./DataFlow.vue?vue&type=script&lang=js"
export * from "./DataFlow.vue?vue&type=script&lang=js"
import style0 from "./DataFlow.vue?vue&type=style&index=0&id=50f6d495&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports